import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';

import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/system';
import { Stack, Typography, IconButton, Avatar, Button, Tooltip, Alert } from '@mui/material';
import { CloseOutlined, Star, StarBorderOutlined } from '@mui/icons-material';
import { addBookmark, removeBookmark } from '../../utils/firebase';
import { useDispatch, useSelector } from 'react-redux';
import { getBookmarks, selectBook } from '../../redux/actions/bookAction';
import { getAuth } from 'firebase/auth';
import { useHistory } from 'react-router-dom';

export default function BookDisplay({ open, setOpen, bookObject }) {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const book = useSelector((state => state.book))
    const [user, setUser] = useState(false);


    //const dispatch = useDispatch();

    /*const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    };
        const [payload, setPayload] = useState({
        courseName: "",
        courseCode: "",
        courseDesc: "",
        courseCreated: "",
    });
    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })

    */
    const handleClose = () => {
        setOpen(false);
    };


    const style = {
        button: {
            textTransform: "none"
        },
        toggleButton: {
            border: 0,
            padding: 0,
            borderRadius: "50%",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
        dialog: {
            minWidth: matches ? 300 : 200,
            maxWidth: 500,
            margin: "auto",
            '& .MuiDialog-paper	': {
                minWidth: matches ? 500 : 210,
                border: "1px solid black",
                borderRadius: 5
            }
        },
        buttonTable: {
            borderRadius: 5,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            width: 200,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
            },
        },
        favoriteIcon: {
            "&:hover": {
                backgroundColor: "transparent",
            },
            color: "#FFD16A"
        }

    }
    const [clicked, setClicked] = useState(false)

    const bookmark = (e) => {
        e.preventDefault()
        if (bookObject) {
            if (checkBookmark()) {
                for (var x = 0; x < bookmarks.length; x++) {
                    if (bookmarks[x] === bookObject.bookID) {
                        bookmarks.splice(x, 1)
                    }
                }
                removeBookmark(bookObject.bookID)
            } else {
                bookmarks.push(bookObject.bookID)
                addBookmark(bookObject.bookID)
            }
            setClicked(checkBookmark())
        }
    }

    const dispatch = useDispatch();

    useEffect(() => {
        if (getAuth().currentUser) setUser(true)
        if (!book.bookmarkEmpty && book.bookmarks.length <= 0) {
            dispatch(getBookmarks());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clicked])


    const checkBookmark = () => {
        var status = false
        for (var x = 0; x < bookmarks.length; x++) {
            if (bookmarks[x] === bookObject.bookID) status = true;
        }
        return status;
    }

    var bookmarks = book.bookmarks

    const history = useHistory()
    const reserveBook = (e) => {
        e.preventDefault();
        if (bookObject) {
            dispatch(selectBook(bookObject));
            history.push("/reservation")
        }
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="responsive-dialog-title"
            sx={style.dialog}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <Box component="span" sx={{ flexGrow: 1 }} />
                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </Stack>
            <Stack direction="column" alignItems="center" spacing={0} sx={{ margin: 1, marginLeft: matches ? 6 : 2, marginRight: matches ? 6 : 2 }}>
                <Avatar
                    sx={{ width: 220, height: 350, boxShadow: 2 }}
                    variant='square'
                    src={bookObject.bookCover || ".././assets/images/profile.png"}
                >
                    {bookObject.bookTitle ? bookObject.bookTitle.charAt(0) : "B"}
                </Avatar>
                <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold" }}>
                    {bookObject.bookTitle}
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center" }}>
                    By: {bookObject.bookAuthor}
                </Typography>
                <Stack direction="row" spacing={1}>
                    <Typography variant="subtitle2">
                        Year Published: {bookObject.yearPublished},
                    </Typography>
                    <Typography variant="subtitle2">
                        Publisher: {bookObject.bookPublisher}
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Typography variant="subtitle2">
                        Edition: {bookObject.edition},
                    </Typography>
                    <Typography variant="subtitle2">
                        Volume: {bookObject.volume},
                    </Typography>
                    <Typography variant="subtitle2">
                        Pages: {bookObject.pages}
                    </Typography>
                </Stack>
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                    Call Number: {bookObject.callNumber}
                </Typography>
                <Stack direction="row" spacing={2} alignItems='center' sx={{ marginTop: 1 }}>
                    <Button disabled={!user} variant="contained" sx={style.buttonTable} onClick={reserveBook}>Reserve Now</Button>
                    <Tooltip title={clicked ? "Added to Bookmark" : "Add to Bookmark"} placement="top">
                        <IconButton disabled={!user} sx={style.favoriteIcon} onClick={bookmark}>
                            {clicked ? <Star sx={{ fontSize: 40 }} /> : <StarBorderOutlined sx={{ fontSize: 40 }} />}
                        </IconButton>
                    </Tooltip>
                </Stack>
                {!user && <Alert severity="error">Please sign in to reserve and add this book to your bookmarks!</Alert>}
                <Box sx={{ height: matches ? 20 : 10 }} />
            </Stack>
        </Dialog>
    );
}